export default __webpack_public_path__ + "static/media/customer06.022011a3.jpg";